// @core/api/endpoints/knowledge/list_knowledge_bases.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListKnowledgeBasesResponse,
} from '../../../types/knowledge';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/knowledge';

/**
 * List knowledge bases
 * Lists knowledge bases visible to the caller, with filtering and pagination.
 */
export async function ListKnowledgeBases(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListKnowledgeBasesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/knowledge/bases`;
  const requestOptions = options;
  return client.get<ListKnowledgeBasesResponse>(requestPath, { ...requestOptions, params });
}
